var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 18.3335V22.3335C25 23.0407 24.719 23.719 24.219 24.2191C23.7189 24.7192 23.0406 25.0002 22.3333 25.0002H3.66667C2.95942 25.0002 2.28115 24.7192 1.78105 24.2191C1.28095 23.719 1 23.0407 1 22.3335V18.3335",
    stroke: "#00AEEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6668 7.66667L13.3537 1.35355C13.1585 1.15829 12.8419 1.15829 12.6466 1.35355L6.3335 7.66667",
    stroke: "#00AEEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.3335L13 17.0002",
    stroke: "#00AEEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropBox);
export default __webpack_public_path__ + "static/media/drop-box.9c426239c023ff5ae128cec670875315.svg";
export { ForwardRef as ReactComponent };